export default __webpack_public_path__ + "static/media/the-cube.b1e31c12.png";